var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.informPassword
        ? _c(
            "v-form",
            { ref: "formPass" },
            [
              _c("v-text-field", {
                attrs: {
                  "prepend-icon": "lock",
                  label: "Informe sua senha",
                  type: "password",
                  rules: [_vm.validatePassword]
                },
                model: {
                  value: _vm.password,
                  callback: function($$v) {
                    _vm.password = $$v
                  },
                  expression: "password"
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }